import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

export default function NewsSidebar({ newsData }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);

  return (
    <div className="PreA_right">
      <div className="PreA_marginMobile">
        <div className='PreA_right-searchBlock flex_row flex_ai-c'>
          <div className='of_hidden' style={{ width: '100%' }}>
            <input
              className="PreA_input flex_full"
              style={{ width: '100%' }}
              type="text"
              placeholder="搜索文章"
            />
            <div className='PreA_input-line'></div>
          </div>
          <img
            className='PreA_right-icon flex_auto'
            src='/images/news/right.png'
            alt=''
          />
        </div>
        <div className="article_rightType">
          <div className='fz_18 fw_500 lh_21'>文章分类</div>
          <div className="article_rightType-block">
            <div className='PreA_right-item flex_center'>公司资讯</div>
            <div className='PreA_right-item flex_center'>最新资讯</div>
          </div>
        </div>
        <div className="article_rightMore">
          <div className='fz_18 fw_500 lh_21'>更多资讯</div>
          <div className='mt_16'>
            <div className="of_hidden">
              <div className='article_rightMoreBlock flex_col'>
                {newsData.map((item, index) => (
                  <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={() => navigate(item.route)}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>最新资讯</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="PreA_right-btnBlock">
            <div
              className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={() => navigate('/companyNews')}
            >
              全部资讯
              <img
                className="PreA_right-arrow"
                alt=""
                src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
